import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteManyClientContactActions } from "store/ducks/settings/client-contact";

export function* deleteManyClientContactRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/client-contact/delete`,
      putData
    );

    const { data } = responseBody;
    yield put(DeleteManyClientContactActions.success(data));
    notify("success", "Contatos deletados com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteManyClientContactActions.failure(errorMessage));
  }
}
